import { ServicesConfigCreateData, ServicesConfigData } from "../../../../../../../models/MappingData";
import {  createServicesConfig, editServicesConfig, fetchLanguagesAvailables } from "../../../../../../../api/repositoryEP";
import { TranslationData } from "../../../../../../../models/MappingData";
import { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "antd";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
import './ServicesForm.scss'
import LoadingDataComponent from "../../../../../../common/LoadingData/LoadingDataComponent";
import IconSelector from "../../../../../../IconsMaterialSymbol/IconSelector";
import { MaterialSymbolProps } from "react-material-symbols";



interface ServicesFormProps {
    setDrawerVisible: (visible: boolean) => void;
    drawerVisible: boolean;
    serviceData: ServicesConfigData | null;
    setServiceData: (servicesData: ServicesConfigData | null) => void;
}


const ServicesForm = (props: ServicesFormProps): JSX.Element => {
    const [servicesNames, setServicesNames] = useState<TranslationData[]>([]);
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loadingLanguages, setLoadingLanguages] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const [isEmptyCode, setIsEmptyCode] = useState<boolean>(false);
    const [codeValue, setCodeValue] = useState<string>(
        props.serviceData?.code !== undefined ? props.serviceData.code : ""
    );



    useEffect(() => {
        if (props.serviceData) {
            form.setFieldsValue({
                code: props.serviceData.code,
                internalNote: props.serviceData.internCode,
                sync: props.serviceData.syncReward,
                icon: props.serviceData.icon
            });
            setIconSelected(props.serviceData.icon || "");

        } else {
            form.resetFields();
        }
    }, [props.serviceData]);


    const closeDrawer = () => {
        props.setServiceData(null)
        form.resetFields();
        props.setDrawerVisible(false)
    }


    const modifyServicesName = (index: number, value: string) => {
        const newRoomNames = [...servicesNames];
        newRoomNames[index].value = value;
        setServicesNames(newRoomNames);
    }


    const handleBtnCancel = () => {
        closeDrawer();
    }
    const handleChangeCode = (e: any) => {
        setCodeValue(e.target.value);
    };


    useEffect(() => {

        if (props.drawerVisible) {

            if (props.serviceData) { // estamos editando
                setServicesNames(props.serviceData.name);

            } else { // estamos creando
                setLoadingLanguages(true)
                setLoading(true); // Inicia la carga
                fetchLanguagesAvailables("wa").then((r) => {
                    if (r?.type === 1) {
                        const languages = r.data.map((lang: string) => {
                            return { language: lang, value: '' }
                        })
                        setServicesNames(languages)
                    } else {
                        props.setServiceData(null)
                        form.resetFields();
                        props.setDrawerVisible(false)
                    }
                    setLoading(false); // Finaliza la carga
                    setLoadingLanguages(false);
                })
            }
        }

    }, [props.drawerVisible]);



    const onFinish = (values: any) => {
        setLoading(true);
        //EIDTAR
        if (props.serviceData) {
            const sData: ServicesConfigData = {
                id: props.serviceData.id,
                code: values.code,
                internCode: values.internalNote,
                syncReward: values.sync,
                name: servicesNames,
                icon: iconSelected
            }
            editServicesConfig(sData).then((response) => {
                if (response?.type === 1) {
                    closeDrawer();
                }
                setLoading(false);
            });

        } else {// CREAR

            const sData: ServicesConfigCreateData = {
                code: values.code,
                internNote: values.internalNote,
                syncReward: values.sync,
                name: servicesNames,
                icon: iconSelected
            }

            createServicesConfig(sData).then((response) => {
                if (response?.type === 1) {
                    closeDrawer();
                }
                setLoading(false);
            });
        }
    }
    const [iconSelected, setIconSelected] = useState<string>('');
    const handleIconChange = (iconName: string) => {
        setIconSelected(iconName);
    }


    return (
        <div className='services-form-component'>
            {loadingLanguages ? (
                <LoadingDataComponent />
            ) : (
                <Form form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24} md={24}>
                            <Form.Item
                                label={t("components.tab-mapping.services-config.drawer.name")}
                                required
                                name="names"
                                validateStatus={servicesNames.some(opt => !opt.value.trim()) ? "error" : ""}
                                help={
                                    servicesNames.some(opt => !opt.value.trim())
                                        ? t("components.tab-mapping.services-config.drawer.name-required")
                                        : ""
                                }
                            >
                                {servicesNames.map((item, optIndex) => (
                                    <div key={optIndex}
                                     className="name-container">
                                        <span>{item.language.substring(item.language.length - 2).toUpperCase()}</span>
                                        <Input
                                            value={item.value}
                                            onChange={(e) => modifyServicesName(optIndex, e.target.value)}
                                          className="input"
                                        />
                                    </div>
                                ))}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item
                                name="icon"
                                required
                                label={t("components.tab-mapping.room-config.drawer.icon")}
                            >
                                <IconSelector
                                    onChange={handleIconChange}
                                    value={iconSelected as MaterialSymbolProps["icon"]}
                                />


                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <Form.Item
                                name="code"
                                label={t("components.tab-mapping.room-config.drawer.code-in-pms")}
                                initialValue={props.serviceData?.code}

                            >
                                <Input className="app-input"
                                    value={codeValue}
                                    onChange={handleChangeCode}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <Form.Item
                                name="internalNote"
                                label={t("components.tab-mapping.services-config.drawer.internal-note")}
                                initialValue={props.serviceData?.internCode}
                            >
                                <Input className="app-input" />
                            </Form.Item>
                        </Col>


                        <Col xs={24} md={12}>
                            <Form.Item className="button-container">
                                <Button className="app-white-button width-95" onClick={handleBtnCancel}>
                                    {t("components.button.cancel")}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item className="button-container">
                                <Button className="app-button width-95"                                    htmlType="submit"
                                    disabled={loading || isEmptyCode || !iconSelected || servicesNames.some(option => !option.value.trim())}
                                    loading={loading}
                                >
                                    {t("components.button.save")}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}
        </div>
    )
}

export default ServicesForm;